import React from 'react'
import { trace } from '@dt/fe-utils'
import './index.scss'

interface IProps {}
interface IState {
  hasComponentError: boolean;
}

class ErrorBoundary extends React.PureComponent<IProps, IState> {
  constructor (props: IProps) {
    super(props)
    this.state = { hasComponentError: false }

    this.handleRefresh = this.handleRefresh.bind(this)

    // // console.error Loading chunk failed
    // const origin = console.error
    // console.error = (error) => {
    //   if (/Loading chunk .* failed/gi.test(error.message) || error?.message?.includes('chunk.js')) {
    //     window.location.reload()
    //   } else {
    //     origin(error)
    //   }
    // }
  }

  componentDidCatch (error: any, info: any) {
    // Display fallback UI
    this.setState({ hasComponentError: true })
    // You can also log the error to an error reporting service
    console.error('component catch', error, info)
    trace.traceLog({
      name: '框架: => 组件渲染异常',
      message: { error: error, info: info }
    })
  }

  handleRefresh () {
    localStorage.clear()
    window.location.reload()
  }

  render () {
    if (this.state.hasComponentError) {
      return (
        <div className='error-boundary-wrap'>
          <p>Oops!!</p>
          <p>{i18n.t('common.systemError')}</p>
          <p className='btn-refresh' onClick={this.handleRefresh}>{i18n.t('common.systemRefresh')}</p>
        </div>
      )
    }
    return (<>{this.props.children}</>)
  }
}

export default ErrorBoundary
